module.exports = __webpack_public_path__ + "img/icon-sarpras.f61d95d4.png";